import { App, type URLOpenListenerEvent } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import * as React from "react";
import { useHistory } from "react-router-dom";

import { rememberIntent } from "@/utilities/intentNavigator";

// 許可するドメインの判定（通知等と同等の許可範囲）
const allowUrl = (u?: string) => {
  if (!u) return false;
  try {
    const url = new URL(u);
    const ALLOW = ["propally.co.jp", "www.propally.co.jp", "propally.jp", "www.propally.jp"];
    return url.protocol === "https:" && ALLOW.includes(url.hostname);
  } catch {
    return false;
  }
};

// 受け取ったURLからアプリ内パスを生成
const resolvePath = (u?: string): string | null => {
  if (!allowUrl(u)) return null;
  try {
    const url = new URL(u!);
    // 任意のパスをそのまま SPA ルートへ橋渡し
    return url.pathname + url.search + url.hash;
  } catch {
    return null;
  }
};

const DeepLinkRouter: React.FC = () => {
  const history = useHistory();

  const enabled = React.useMemo(() => {
    if (typeof window === "undefined") return false;
    try {
      return Capacitor.getPlatform() !== "web";
    } catch {
      return false;
    }
  }, []);

  React.useEffect(() => {
    if (!enabled) return; // webでは何もしない

    let remove: (() => void) | undefined;

    // 冷起動時のURL対応
    App.getLaunchUrl()
      .then((r) => {
        const dest = resolvePath(r?.url);
        if (dest) {
          rememberIntent(dest);
          history.replace(dest);
        }
      })
      .catch(() => {});

    // フォアグラウンドでのURLオープン
    const p = App.addListener("appUrlOpen", (e: URLOpenListenerEvent) => {
      const dest = resolvePath(e.url);
      if (dest) {
        rememberIntent(dest);
        history.push(dest);
      }
    });
    p.then((sub) => {
      remove = () => sub.remove();
    });

    return () => {
      remove?.();
    };
  }, [enabled, history]);

  return null;
};

export default DeepLinkRouter;
